import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX } from "react";

interface Props {
    isPostCreateCertificateLoading: boolean;
    className?: string;
}

export const SubmitButtonComponent = (props: Props): JSX.Element => {
    const { isPostCreateCertificateLoading, className } = props;
    let newClassName =
        "c-create-certificate-modal__form-group c-create-certificate-modal__form-group--button";

    if (className) {
        newClassName = className;
    }

    return (
        <div className={newClassName}>
            <Button
                loading={isPostCreateCertificateLoading}
                variant={"primary"}
                disabled={isPostCreateCertificateLoading}
                type={"submit"}
            >
                Certificaat toevoegen
            </Button>
        </div>
    );
};
